import * as React from 'react';

const style = require('./index.css');

interface ITimeLabelProps {
  added: string;
  humanizedTime: string;
}

export const TimeLabel = (props: ITimeLabelProps) => {
  return (
    <div className={style['time-label']}>
      <div className={style['relative']}>{props.humanizedTime}</div>
      <div className={style['absolute']}>{props.added}</div>
    </div>
  );
};
